export default __webpack_public_path__ + "static/media/layerLeft2.18198f79.webp";